export const tickets = [
  {
    id: "ticket-001",
    type: "bug",
    title: "Ошибка обработки платежей для карт Visa",
    status: "in-progress",
    priority: "high",
    assignee: { id: "user-002", name: "Мария Иванова", role: "Senior Backend Developer" },
    reporter: { id: "user-016", name: "Кирилл Орлов", role: "Payment Systems Specialist" },
    created: "2023-04-22T09:15:00",
    updated: "2023-04-28T14:30:00",
    description: `При обработке платежей через карты Visa возникает ошибка в 15% случаев. Ошибка происходит на этапе авторизации платежа. Логи показывают HTTP статус 422 от платежного шлюза.

    Шаги воспроизведения:
    1. Попробовать совершить платеж картой Visa
    2. В 15% случаев платеж не проходит с ошибкой "Ошибка авторизации платежа"

    Необходимо исследовать проблему и найти решение, так как это критично для бизнеса.`
  },
  {
    id: "ticket-002",
    type: "feature",
    title: "Внедрение GraphQL API для мобильного приложения",
    status: "in-progress",
    priority: "medium",
    assignee: { id: "user-008", name: "Наталья Козлова", role: "Frontend Developer" },
    reporter: { id: "user-005", name: "Иван Кузнецов", role: "Product Manager" },
    created: "2023-04-10T13:45:00",
    updated: "2023-04-27T11:20:00",
    description: `Необходимо разработать GraphQL API для мобильного приложения, который позволит эффективно загружать только нужные данные.

    Требования:
    1. Реализовать GraphQL схему, отражающую основные сущности системы
    2. Обеспечить авторизацию через JWT
    3. Реализовать кэширование на стороне клиента
    4. Документировать API для мобильной команды`
  },
  {
    id: "ticket-003",
    type: "improvement",
    title: "Оптимизация времени загрузки главной страницы",
    status: "open",
    priority: "high",
    assignee: { id: "user-008", name: "Наталья Козлова", role: "Frontend Developer" },
    reporter: { id: "user-009", name: "Андрей Соколов", role: "Performance Engineer" },
    created: "2023-04-08T15:20:00",
    updated: "2023-04-09T10:05:00",
    description: `Текущее время загрузки главной страницы составляет более 3 секунд, что негативно влияет на пользовательский опыт и SEO. Необходимо оптимизировать загрузку и сократить время до первого интерактивного состояния.

    Предлагаемые меры:
    1. Внедрить code-splitting для ленивой загрузки компонентов
    2. Оптимизировать критический путь рендеринга
    3. Сократить размер бандла JavaScript
    4. Оптимизировать загрузку изображений`
  },
  {
    id: "ticket-004",
    type: "feature",
    title: "Реализация системы уведомлений в реальном времени",
    status: "resolved",
    priority: "medium",
    assignee: { id: "user-001", name: "Алексей Петров", role: "Tech Lead" },
    reporter: { id: "user-005", name: "Иван Кузнецов", role: "Product Manager" },
    created: "2023-03-15T11:30:00",
    updated: "2023-04-20T16:45:00",
    description: `Необходимо разработать систему уведомлений в реальном времени для веб и мобильного приложения.

    Требования:
    1. Поддержка различных типов уведомлений (личные сообщения, системные оповещения, обновления)
    2. Настройка предпочтений пользователя по уведомлениям
    3. Возможность группировки уведомлений
    4. История уведомлений с возможностью поиска

    Технический стек: WebSockets, Redis для обработки очередей, Firebase для мобильных push-уведомлений.`
  },
  {
    id: "ticket-005",
    type: "task",
    title: "Разработка микросервиса авторизации",
    status: "open",
    priority: "high",
    assignee: { id: "user-002", name: "Мария Иванова", role: "Senior Backend Developer" },
    reporter: { id: "user-001", name: "Алексей Петров", role: "Tech Lead" },
    created: "2023-04-16T09:00:00",
    updated: "2023-04-16T09:30:00",
    description: `В рамках миграции на микросервисную архитектуру необходимо выделить функционал авторизации в отдельный сервис.

    Задачи:
    1. Разработать API для авторизации и аутентификации
    2. Реализовать управление JWT токенами
    3. Поддержка OAuth для внешних провайдеров
    4. Интеграция с текущей системой прав и ролей

    Технический стек: Node.js, Express, MongoDB, Redis для кэширования токенов.`
  },
  {
    id: "ticket-006",
    type: "bug",
    title: "Уязвимость в системе хранения данных карт",
    status: "open",
    priority: "critical",
    assignee: { id: "user-015", name: "Павел Соловьев", role: "Security Engineer" },
    reporter: { id: "user-016", name: "Кирилл Орлов", role: "Payment Systems Specialist" },
    created: "2023-04-27T16:30:00",
    updated: "2023-04-27T17:15:00",
    description: `В процессе аудита безопасности выявлена критическая уязвимость в системе хранения данных платежных карт. Текущая реализация не соответствует требованиям PCI DSS.

    Проблемы:
    1. Недостаточное шифрование при хранении данных
    2. Отсутствие механизма ротации ключей шифрования
    3. Журналирование содержит чувствительную информацию

    Требуется срочно устранить уязвимость до следующего аудита безопасности.`
  },
  {
    id: "ticket-007",
    type: "task",
    title: "Разработка курса онбординга для новых разработчиков",
    status: "in-progress",
    priority: "medium",
    assignee: { id: "user-011", name: "Елена Павлова", role: "HR Manager" },
    reporter: { id: "user-012", name: "Владимир Никитин", role: "Head of Engineering" },
    created: "2023-04-06T13:45:00",
    updated: "2023-04-21T11:20:00",
    description: `Необходимо разработать структурированный курс онбординга для новых разработчиков, который поможет им быстрее адаптироваться в команде и проекте.

    Содержание курса должно включать:
    1. Обзор архитектуры проекта и технического стека
    2. Процессы разработки и основные правила
    3. Обзор ключевых компонентов системы
    4. Набор "стартовых" задач для быстрого погружения

    Результатом должна стать интерактивная документация и набор чек-листов для новых сотрудников.`
  },
  {
    id: "ticket-008",
    type: "feature",
    title: "Редизайн мобильного приложения",
    status: "in-progress",
    priority: "high",
    assignee: { id: "user-006", name: "Ольга Новикова", role: "UX Designer" },
    reporter: { id: "user-005", name: "Иван Кузнецов", role: "Product Manager" },
    created: "2023-04-19T10:15:00",
    updated: "2023-04-26T16:40:00",
    description: `В соответствии с результатами пользовательских исследований, необходимо выполнить редизайн мобильного приложения для повышения удобства использования и модернизации внешнего вида.

    Основные направления работы:
    1. Обновление дизайн-системы в соответствии с новым брендингом
    2. Редизайн основных экранов с учетом UX-исследований
    3. Оптимизация навигации и информационной архитектуры
    4. Улучшение доступности для пользователей с ограниченными возможностями

    Дизайн должен быть оформлен в Figma с подробной документацией компонентов.`
  },
  {
    id: "ticket-009",
    type: "improvement",
    title: "Упрощение процесса регистрации в мобильном приложении",
    status: "open",
    priority: "high",
    assignee: { id: "user-014", name: "Геннадий Захаров", role: "Mobile Developer" },
    reporter: { id: "user-013", name: "Анна Морозова", role: "Data Analyst" },
    created: "2023-04-26T09:30:00",
    updated: "2023-04-26T10:15:00",
    description: `Аналитика показывает высокий процент отказа пользователей (47%) на этапе регистрации в мобильном приложении. Необходимо упростить процесс для повышения конверсии.

    Предлагаемые изменения:
    1. Сократить количество обязательных полей при регистрации
    2. Добавить возможность регистрации через социальные сети
    3. Реализовать пошаговую форму с прогресс-баром
    4. Отложить запрос необязательной информации на более поздний этап

    Ожидаемый результат: снижение показателя отказа до 25% в течение месяца после внедрения.`
  },
  {
    id: "ticket-010",
    type: "feature",
    title: "Разработка системы персонализированных рекомендаций",
    status: "open",
    priority: "medium",
    assignee: { id: "user-013", name: "Анна Морозова", role: "Data Analyst" },
    reporter: { id: "user-005", name: "Иван Кузнецов", role: "Product Manager" },
    created: "2023-04-20T11:20:00",
    updated: "2023-04-20T13:45:00",
    description: `Необходимо разработать систему персонализированных рекомендаций для пользователей на основе их поведения и предпочтений.

    Требования:
    1. Сбор и анализ данных о поведении пользователей
    2. Разработка алгоритмов рекомендаций на основе машинного обучения
    3. Интеграция рекомендаций в пользовательский интерфейс
    4. A/B тестирование различных алгоритмов рекомендаций

    Технический стек: Python для аналитики и ML, API для интеграции с фронтендом, система мониторинга качества рекомендаций.`
  },
  {
    id: "ticket-011",
    type: "improvement",
    title: "Оптимизация системы уведомлений для повышения удержания",
    status: "in-progress",
    priority: "medium",
    assignee: { id: "user-005", name: "Иван Кузнецов", role: "Product Manager" },
    reporter: { id: "user-013", name: "Анна Морозова", role: "Data Analyst" },
    created: "2023-04-24T14:30:00",
    updated: "2023-04-26T09:15:00",
    description: `Необходимо оптимизировать систему уведомлений для улучшения показателей удержания пользователей. Текущие метрики показывают низкий показатель возвращения (<30%).

    Предлагаемые изменения:
    1. Разработать стратегию умных уведомлений на основе пользовательской активности
    2. Персонализировать содержание и время отправки уведомлений
    3. Внедрить сегментацию пользователей для таргетированных уведомлений
    4. Реализовать простую систему настройки уведомлений для пользователей

    Ожидаемый результат: повышение показателя возврата пользователей до 50% в течение 2 месяцев.`
  },
  {
    id: "ticket-012",
    type: "task",
    title: "Подготовка плана реорганизации команды разработки",
    status: "open",
    priority: "high",
    assignee: { id: "user-012", name: "Владимир Никитин", role: "Head of Engineering" },
    reporter: { id: "user-010", name: "Максим Белов", role: "CTO" },
    created: "2023-04-21T10:00:00",
    updated: "2023-04-21T10:30:00",
    description: `В связи с ростом компании и расширением функций продукта, необходимо подготовить детальный план реорганизации команды разработки.

    План должен включать:
    1. Новую структуру команды с разделением на 3 направления
    2. Четкое описание ролей и зон ответственности
    3. Процесс перехода от текущей структуры к новой
    4. Механизмы коммуникации между новыми командами
    5. Таймлайн внедрения изменений

    Результатом должен стать детальный документ для презентации всей команде.`
  }
]; 